export const usePaginateGoBack = ({ setPage, total, pageCount }) => {
  return (deletedItemsCount = 1) => {
    if (pageCount > 0 && total % 10 == deletedItemsCount) {
      setPage((prev) => prev - 1);
    }
  };
};
